import {APIError} from 'data/errors/api-error';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {PostGraceBotEvent} from 'domain/usecases/private/my-payments-flow/post-grace-bot-event';
import {
	PostGraceBotEventParams,
	PostGraceBotEventResponse,
} from 'domain/usecases/private/my-payments-flow/post-grace-bot-event/types';

export class RemotePostGraceBotEvent implements PostGraceBotEvent {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<PostGraceBotEventResponse>,
	) {}

	async post(params: PostGraceBotEventParams): Promise<PostGraceBotEventResponse> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'post',
			body: params,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
			case HttpStatusCode.created:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
